/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const conversationWindowDataSchema = z.object({
	isOpen: z.boolean(),
	expiresAt: z.iso.datetime().nullable(),
	lastInboundAt: z.iso.datetime().nullable(),
})

export type ConversationWindowDataSchema = z.infer<typeof conversationWindowDataSchema>
